import React, { ReactNode } from 'react'
import { Translate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { isEmpty, omit, pickBy } from 'lodash-es'
import { fetchProfile } from 'core/actions/Profile.actions'
import Permissions from 'shared/components/fields/permissions'
import FormStepper from 'shared/components/form-stepper'
import { FormMode } from 'shared/interfaces'
import { Spinner } from '@digicert/dcone-common-ui'
import { getterHash, goNextStepHandler } from 'core/utils/helpers'
import { IAppState } from 'core/store/store'
import { IUserFormStateProps, IUserFormType, IUserFormValues } from './UserForm.types'
import { UserFormAdapter, UserFormFields, userFormSelector } from './UserForm.constants'
import UserFormWrapper from './UserFormWrapper'
import GeneralInfo from './GeneralInfo'
import { IAccessScope } from 'reducers/Reducers.interfaces'
import { removeItemFromLS } from 'shared/helpers/LocalStorage'
import history from 'core/history/history'
import { change } from 'redux-form'
import { getAllPermissionsBasedOnUserMeApi } from './UserForm.helpers'

class UserForm extends FormStepper<IUserFormType> {
  state = {
    step: this.props.location.hash ? getterHash(this.props.location) : this.props.step ? this.props.step : 0,
    lastPage: 1,
    showConfirmModal: false
  }

  public async componentDidMount (): Promise<void> {
    this.props.fetchProfile()
  }

  protected getTitleForm () {
    return (
      <Translate id={`manageUser.administrators.form.${this.state.step === 1 ? 'generalInfo' : 'adminPermissions'}`} />
    )
  }

  private onCancel = (): void => {
    history.goBack()
  }

  private getInitialValues = (): Partial<IUserFormValues> => {
    const { user, mode, allPermissions, localeList } = this.props
    if (this.state.step === 0) {
      removeItemFromLS('accessScope')
    }

    if (user && mode === FormMode.edit) {
      const primary_account = user.accounts.find(account => account.id === user.primary_account_id)
      return {
        ...(omit(user, ['active', 'pending', 'id'])),
        email: user.email,
        primary_account: primary_account ? primary_account.name : '',
        mode: mode,
        saml_username: user.saml_username,
        access_scope: user.access_scope === IAccessScope.system,
        permissions: user.permissions.reduce((result, item) => ({ ...result, [item.id]: true }), {}),
        allPermissions: allPermissions,
        language: user ? localeList.locales.filter(locale => locale.id === user.locale)[0] : undefined
      }
    } else {
      return {
        permissions: {},
        allPermissions: allPermissions,
        [UserFormFields.accessScope]: false
      }
    }
  }

  protected getCurrentForm (): ReactNode {
    const { userProfile, allPermissions, editingDisabled, onCancel, featureEnabled, keylockerEnabled } = this.props
    if (!userProfile) {
      return <Spinner/>
    }
    const allPerms = getAllPermissionsBasedOnUserMeApi(allPermissions, userProfile)
    switch (this.state.step) {
      case 0:
        return (
          <UserFormWrapper
            onSubmit={goNextStepHandler(this.state.step, this.props.location)}
            goBack={this.props.goBack}
            onCancel={history.goBack}
            step={this.state.step}
            initialValues={this.getInitialValues()}
            lastPage={this.state.lastPage}
            isLoading={this.props.loading}
            mode={this.props.mode}
          >
            <GeneralInfo
              // todo ashwini Property mode does not exist on type IntrinsicAttributes & object
              // @ts-ignore
              mode={this.props.mode}
              profileAccessScope={this.props.profileAccessScope}
              permissions={this.props.permissions}
              tenants={this.props.tenants}
              accounts={this.props.accounts}
              samlLogin={this.props.samlLogin}
              user={this.props.user}
              localeList={this.props.localeList}
              change={this.props.change}
            />
          </UserFormWrapper>
        )
      case 1:
        return (
          <UserFormWrapper
            onSubmit={this.props.onSubmit}
            goBack={this.props.goBack}
            onCancel={onCancel ? onCancel : this.onCancel}
            step={this.state.step}
            initialValues={this.getInitialValues()}
            lastPage={this.state.lastPage}
            isLoading={this.props.loading}
            mode={this.props.mode}
            isDisabled={isEmpty(pickBy(this.props.currentPermissions, p => p))}
            editingDisabled={editingDisabled}
            featureEnabled={featureEnabled}
          >
            <Permissions
              formName={UserFormAdapter.name}
              mode={this.props.mode}
              profilePermissions={this.props.profilePermissions}
              allPermissions={allPerms}
              currentPermissions={this.props.currentPermissions}
              canManagePermission={this.props.canManagePermission}
              loading={this.props.loading}
              currentAccessScope={this.props.currentAccessScope}
              profileAccessScope={this.props.profileAccessScope}
              featureIds={this.props.features}
              editingDisabled={editingDisabled}
              keylockerEnabled={keylockerEnabled}
            />
          </UserFormWrapper>
        )
    }
  }
}

export default connect(
  (state: IAppState): IUserFormStateProps => {
    return {
      tenants: state.tenants.items,
      accounts: state.profile.data!.accounts,
      profileAccessScope: state.profile.data!.access_scope,
      profilePermissions: state.profile.data!.permissions,
      currentPermissions: userFormSelector(state, UserFormFields.permissions),
      allPermissions: state.profile.permissions,
      localeList: state.locales,
      userProfile: state.userProfile.data
    }
  },
  { change, fetchProfile }
)(UserForm)
